/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AuthorisePaymentTestOptions
 */
export interface AuthorisePaymentTestOptions {
    /**
     * 
     * @type {boolean}
     * @memberof AuthorisePaymentTestOptions
     */
    force3DSecure?: boolean;
}

/**
 * Check if a given object implements the AuthorisePaymentTestOptions interface.
 */
export function instanceOfAuthorisePaymentTestOptions(value: object): value is AuthorisePaymentTestOptions {
    return true;
}

export function AuthorisePaymentTestOptionsFromJSON(json: any): AuthorisePaymentTestOptions {
    return AuthorisePaymentTestOptionsFromJSONTyped(json, false);
}

export function AuthorisePaymentTestOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuthorisePaymentTestOptions {
    if (json == null) {
        return json;
    }
    return {
        
        'force3DSecure': json['force3DSecure'] == null ? undefined : json['force3DSecure'],
    };
}

export function AuthorisePaymentTestOptionsToJSON(json: any): AuthorisePaymentTestOptions {
    return AuthorisePaymentTestOptionsToJSONTyped(json, false);
}

export function AuthorisePaymentTestOptionsToJSONTyped(value?: AuthorisePaymentTestOptions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'force3DSecure': value['force3DSecure'],
    };
}

